// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"05a72114","453":"39fc32f7","735":"d192d58a"}[chunkId] + ".chunk.js";
};